import React from "react";
import CalcItem from "./CalcItem/CalcItem";

function App({ locale = "en" }) {
	return <CalcItem locale={locale} />;
}

export default App;
